import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { connect } from "react-redux";
import ReactTable from 'react-table';
import SaveStorewiseAsinForAssetsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SaveStorewiseAsinForAssetsService';
import getCMAssetCountsByASINService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/getCMAssetCountsByASINService';

function NewCMProductListScreen(props) {
  const [asins, setAsins] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    
    let parsedAsins = [];
    
    if (props.asinList) {
      if (Array.isArray(props.asinList)) {
        // If it's already an array, convert all items to strings and remove duplicates
        parsedAsins = [...new Set(props.asinList.map(String).filter(asin => asin && asin.trim()))];
      } else if (typeof props.asinList === 'string') {
        // If it's a string, split by comma and clean up
        parsedAsins = [...new Set(
          props.asinList.split(',')
            .map(asin => asin.trim())
            .filter(asin => asin)
        )];
      }
    }
    
    setAsins(parsedAsins);
    
    // Initialize selected titles based on the parsed asins
    if (parsedAsins.length > 0 && props.productList) {
      const titles = parsedAsins.map(asin => {
        const product = props.productList.find(p => p.asin === asin);
        return product ? product.productTitle : '';
      }).filter(title => title);
      setSelectedTitles(titles);
    }
  }, [props.asinList, props.productList]);

  // const selectedAsinList = (asin, productTitle) => {
  //   setAsins(prev => {
  //     if (props.singleSelect) {
  //       // For single select, set the title directly
  //       setSelectedTitles([productTitle]);
  //       return [String(asin)];
  //     } else {
  //       // For multiple select
  //       const normalized = prev.map(String);
  //       if (normalized.includes(String(asin))) {
  //         // Remove asin and its corresponding title
  //         const asinIndex = normalized.indexOf(String(asin));
  //         setSelectedTitles(prevTitles => prevTitles.filter((_, index) => index !== asinIndex));
  //         return normalized.filter(item => item !== String(asin));
  //       } else {
  //         // Add asin and its title
  //         setSelectedTitles(prevTitles => [...prevTitles, productTitle]);
  //         return Array.from(new Set([...normalized, String(asin)]));
  //       }
  //     }
  //   });
  // };
  const selectedAsinList = (asin, productTitle) => {
    setAsins(prev => {
      const asinStr = String(asin);
      const normalized = prev.map(String);
  
      const selectedProduct = props.productList.find(p => String(p.asin) === asinStr);
      if (!selectedProduct) return normalized;
  
      let updatedAsins = [...normalized];
      let updatedTitles = [...selectedTitles];
  
      const isParent = selectedProduct.isParentProduct;
  
      if (props.singleSelect) {
        setSelectedTitles([productTitle]);
        return [asinStr];
      }
  
      if (isParent) {
        const childAsins = props.productList
          .filter(p => String(p.parentProduct) === asinStr && String(p.asin) !== asinStr)
          .map(p => String(p.asin));
  
        const childTitles = props.productList
          .filter(p => String(p.parentProduct) === asinStr && String(p.asin) !== asinStr)
          .map(p => p.productTitle);
  
        if (updatedAsins.includes(asinStr)) {
          updatedAsins = updatedAsins.filter(a => a !== asinStr && !childAsins.includes(a));
          updatedTitles = updatedTitles.filter(title =>
            title !== productTitle && !childTitles.includes(title)
          );
        } else {
          updatedAsins = Array.from(new Set([...updatedAsins, asinStr, ...childAsins]));
          updatedTitles = [...updatedTitles, productTitle, ...childTitles];
        }
      } else {
        if (updatedAsins.includes(asinStr)) {
          updatedAsins = updatedAsins.filter(a => a !== asinStr);
          updatedTitles = updatedTitles.filter(title => title !== productTitle);
        } else {
          updatedAsins.push(asinStr);
          updatedTitles.push(productTitle);
        }
      }
  
      setSelectedTitles(Array.from(new Set(updatedTitles)));
  
      return Array.from(new Set(updatedAsins));
    });
  };
  
  const fetchUpdatedCounts = () => {
      const asinList = props.productList ? props.productList.map(p => p.asin) : [];
      const data = {
          asinList: asinList,
          integerId: props.selectedProjectData.integerId,
          assetCategory: props.selectedSubCategories.assetCategory,
          subCategoryId: props.selectedSubCategories.id,
          projectId: props.selectedProjectData.projectId,
      };

      getCMAssetCountsByASINService(props.token, data).then((res) => {
          if (res) {
              console.log("Counts updated directly from Modal:", res);
              if(props.setAsinAssetCounts) {
                  props.setAsinAssetCounts(res);
              }
          }
      });
  }

  const handleStoreWiseProducts = () => {
    if (props.action == true) {
      props.setAsinList(asins);
      
      // Pass the selected titles to parent component
      if (props.setSelectedTitles) {
        if (props.singleSelect && selectedTitles.length > 0) {
          props.setSelectedTitles(selectedTitles[0]);
        } else {
          props.setSelectedTitles(selectedTitles);
        }
      }
      
      props.setAddProductsPopup(false);
      return;
    }
    
    if (props.action == false) {
      let data = {
        fileID: props.selectedImage.id,
        asinsList: asins,
        selectedTitles: selectedTitles,
        integerId: props.selectedProjectData.integerId,
        projectId: props.selectedProjectData.projectId,
        assetCategory: props.selectedSubCategories.assetCategory,
        assetIdentifier: props.selectedProjectData.brand,
        subCategoryId: props.selectedSubCategories.id,
      }
     
      SaveStorewiseAsinForAssetsService(props.token, data).then((res) => {
        if (res) {
          console.log(res)
          props.setAsinList(res.asinList)
          props.setFileListOfAssets(res.fileList.fileList)
          const updatedAsset = res.fileList.fileList.find(file => file.id === props.selectedImage.id);
          if (updatedAsset) {
            props.setFileListOfAssets(prev => 
              prev.map(file => 
                file.id === props.selectedImage.id ? updatedAsset : file
              )
            );
          }

          if(props.documentScreen==false){
            props.setSelectedASIN(null)
          }

          fetchUpdatedCounts();
          
          props.setAddProductsPopup(false)
        }
      })
    }
  }

  const columns = [
    {
      Header: "Select",
      accessor: "asin",
      width: 80,
      Cell: (cellInfo) => {
        const isChecked = asins && asins.map(String).includes(String(cellInfo.value));
        return (
          <div className="d-flex justify-content-center w-100">
            <input
              onChange={() => selectedAsinList(cellInfo.value, cellInfo.original.productTitle)}
              value={cellInfo.value}
              type={props.singleSelect ? "radio" : "checkbox"}
              name={props.singleSelect ? "asinRadioGroup" : cellInfo.value}
              checked={isChecked}
            />
          </div>
        );
      },
    },
    {
      Header: "Parent Asin",
      accessor: "parentProduct",
      width: 110,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Asin",
      accessor: "asin",
      width: 110,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Product Title",
      accessor: "productTitle",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p title={cellInfo.value} className='mb-0 comment-paragraph-ticket-history'>{cellInfo.value}</p>
        </div>
      ),
    },
  ]

  const filterProductData = props.productList && props.productList.filter((row) => {
    const parentProduct = (row.parentProduct || '').toLowerCase();
    const isParentProduct = row.isParentProduct ? 'yes' : 'no';
    const productTitle = (row.productTitle || '').toString().toLowerCase();
    const asin = (row.asin || '').toString().toLowerCase();
    return (
      isParentProduct.includes(searchText.toLowerCase()) ||
      parentProduct.includes(searchText.toLowerCase()) ||
      asin.includes(searchText.toLowerCase()) ||
      productTitle.includes(searchText.toLowerCase())
    );
  });

  return (
    <>
      <Card className='curve-popup p-3'>
        <Row>
          <Col md={12}>
            <Input
              className="mb-2 w-50"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search Product by Title and ASIN "
            />
          </Col>
          <Col md={12}>
            <ReactTable
              data={filterProductData}
              columns={columns}
              className="-fixed -highlight -striped mt-2"
              getTheadProps={() => ({
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              })}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                  return {
                    style: {
                      backgroundColor: '#dfd7ff', 
                    },
                  };
                }
                return {};
              }}
              defaultPageSize={5}
              noDataText={"No Data Found."}
            />
          </Col>
          
          <Col className="d-flex justify-content-center mt-2">
            <Button
              className="btn-background-color"
              onClick={() => handleStoreWiseProducts()}
            >
              Done
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
  };
};

export default connect(mapStateToProps)(NewCMProductListScreen);